import {
    ranks,
    professions,
    specializations,
    rankTexts,
    professionText,
    specializationText,
} from "../../data";

function BridgeOfficer({ bridgeOfficer, style, onClick, className }) {
    let urlParts = [];
    let fileParts = [];
    let textParts = [];

    urlParts.push(process.env.PUBLIC_URL);
    urlParts.push("img");
    urlParts.push("boff");
    fileParts.push("Boff");
    fileParts.push(bridgeOfficer.rank ? ranks[bridgeOfficer.rank] : "rankless");
    textParts.push(
        bridgeOfficer.rank ? rankTexts[bridgeOfficer.rank] : "Any Rank"
    );
    fileParts.push(
        bridgeOfficer.profession
            ? professions[bridgeOfficer.profession]
            : "unemployed"
    );
    textParts.push(
        bridgeOfficer.profession
            ? professionText[bridgeOfficer.profession]
            : "Any Class"
    );

    if (bridgeOfficer.specialization) {
        fileParts.push(specializations[bridgeOfficer.specialization]);
        textParts.push(specializationText[bridgeOfficer.specialization]);
    }

    urlParts.push(fileParts.join("_") + ".png");

    return (
        <img
            style={style}
            className={className}
            alt={textParts.join(" ")}
            title={textParts.join(" ")}
            src={urlParts.join("/")}
            onClick={onClick}
        />
    );
}

export default BridgeOfficer;
